<template>
  <div>
    <section class="shop-page py-5">
      <div class="container">
        <div class="row">

          <!-- Sidebar -->
          <aside class="col-md-3 mb-4">
            <div class="d-md-none mb-3">
              <button class="btn btn-filter-toggle w-100" 
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target="#filterCollapse">
                <i class="fas fa-sliders-h me-2"></i> Filters
              </button>
            </div>

            <div class="collapse d-md-block text-start" id="filterCollapse">
              <div class="filter-box p-3 border rounded">
                <h5 class="mb-3">Categories</h5>
                <div v-for="category in categories" :key="category.slug" class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="category.slug"
                    :value="category.slug"
                    v-model="selectedCategories"
                    @change="getProducts"
                  />
                  <label class="form-check-label" :for="category.slug">
                    {{ category.title }}
                  </label>
                </div>

                <hr>
                <h5 class="mb-3">Sort By</h5>
                <select class="form-select" v-model="sortBy" @change="getProducts">
                  <option value="popularity">Popularity</option>
                  <option value="low_to_high">Price: Low to High</option>
                  <option value="high_to_low">Price: High to Low</option>
                  <option value="newest">Newest First</option>
                </select>
              </div>
            </div>
          </aside>

          <!-- Products -->
          <div class="col-md-9">
            <div class="row g-4">
              <div v-if="products.length === 0" class="col-12 text-center py-5">
                <h5 class="text-muted">No products available</h5>
              </div>

              <div v-else v-for="product in products" :key="product._id" class="col-6 col-md-4">
                <div class="card product-card position-relative">
                  <span
                    v-if="product.offerPrice"
                    class="position-absolute top-0 start-0 bg-danger text-white px-2 py-1 rounded-end"
                    style="font-size: 0.8rem;"
                  >
                    {{ product.offerPriceText || 'On Sale' }}
                  </span>
                  <a href="javascript:void(0)" @click="$router.push(`/product/${product.slug}`)" >
                    <img :src="product.mainImageUrl" class="card-img-top" :alt="product.name" />
                  </a>

                  <div class="card-body text-center">
                    <h6 class="card-title">{{ product.name }}</h6>
                    <p class="mb-1">
                      <span v-if="product.offerPrice" class="text-muted text-decoration-line-through me-2">
                        ₹{{ product.price }}
                      </span>
                      <span :class="product.offerPrice ? 'fw-bold text-danger' : 'fw-bold'">
                        ₹{{ product.offerPrice || product.price }}
                      </span>
                    </p>
                    <a href="javascript:void(0)" @click="addProductToCart(product, true)" class="btn btn-accent btn-sm">Buy Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useToast } from 'vue-toast-notification';
const $toast = useToast();
import ProductService from "../services/ProductService";
import { EventBus } from '@/eventBus'

export default {
  name: 'Shop',
  data() {
    return {
      categories: [],
      products: [],
      selectedCategories: [], // now stores slugs
      sortBy: 'popularity'
    };
  },
  methods: {
    getCategories() {
      ProductService.getCategories()
        .then(response => {
          this.categories = response.data.data;

          // Auto-select category from query using slug
          const categoryFromQuery = this.$route.query.category;
          if (categoryFromQuery) {
            const validCategory = this.categories.find(c => c.slug === categoryFromQuery);
            if (validCategory && !this.selectedCategories.includes(categoryFromQuery)) {
              this.selectedCategories.push(categoryFromQuery);
            }
          }

          this.getProducts();
        })
        .catch(e => {
          $toast.error(e.response?.data?.response_msg || e.message);
        });
    },

    getProducts() {
      // Get the slug from URL (single category)
      const categorySlugFromUrl = this.$route.params.slug;

      // Merge with selectedCategories checkboxes
      let categoriesArray = [...this.selectedCategories];

      // If URL has slug but it's not in selectedCategories, add it
      if (categorySlugFromUrl && !categoriesArray.includes(categorySlugFromUrl)) {
        categoriesArray.push(categorySlugFromUrl);
      }

      const data = {
        categories: categoriesArray,
        sortBy: this.sortBy
      };

      ProductService.shop(data)
        .then(response => {
          this.products = response.data.data;
        })
        .catch(e => {
          $toast.error(e.response?.data?.message || e.message);
        });
    },
    async addProductToCart(product, redirectToCartPage = false) {
      let data = {
        productId: product._id,
        productDetail: product,
        qty: 1,
      };

      await ProductService.addProductToCart(data)
        .then((response) => {
          EventBus.emit('cart-updated')
          $toast.success(response.data.respones_msg);
          if (redirectToCartPage) {
            this.$router.push({ path: '/cart' });
          }
        })
        .catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
  },
  watch: {
    '$route.params.slug'(newSlug) {
      this.getProducts();
    }
  },
  created() {
    this.getCategories();
  }
};
</script>
